import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id", "draggable"]
const _hoisted_2 = ["value"]

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, withDefaults, ref } from "vue";

import { defineComponent, computed } from "vue";
const __default__ = defineComponent({
  name: "VZList",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const selectAttr = computed(() => {
  const { options, id, ...rest } = attrs;
  if (rest.style && rest.style.defaultBorder === "true !important") {
    rest.style.borderColor = "";
    rest.style.borderWidth = "";
    rest.style.borderStyle = "";
    rest.style.padding = "";
    rest.style.margin = "";
    rest.borderColor = "";
    rest.borderWidth = "";
    rest.borderStyle = "";
    rest.padding = "";
    rest.margin = "";
  }
  return rest;
});
const options = computed(() => {
  const { options } = attrs;
  return options ?? [];
});
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const isDraggable = computed(() => {
  return attrs?.draggable ?? false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "VZ_TABLE_INPUT",
    id: _unref(attrs).id,
    draggable: _unref(isDraggable)
  }, [
    _createElementVNode("select", _mergeProps(_unref(selectAttr), { style: _unref(style) }), [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: option.value
        }, _toDisplayString(option.text), 9, _hoisted_2))
      }), 128))
    ], 16)
  ], 8, _hoisted_1))
}
}

})